import { ActionType } from 'flow/store/engine/constants';

export const incompatibleSnippetActionTypes = [
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.OUTCOME,
];
